var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteIconPrilogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 118.979,
    height: 134.482,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M61.496.433c-1.249-.612-3.333-.56-4.598.062C38.936 9.328 20.352 16.3.04 19.804c-.282 12.477.97 24.437 3.488 36.261 6.991 32.823 23.634 59.106 52.362 77.235 2.49 1.573 4.264 1.584 6.738-.008 11.93-7.675 22.47-16.85 30.993-28.213 14.11-18.815 21.19-40.335 23.829-63.45.821-7.187 1.03-14.443 1.53-21.81C98.3 16.344 79.594 9.3 61.496.433zM84.58 58.195c-.894 2.279-2.034 4.23-3.497 5.938a14.92 14.92 0 0 1-5.368 4.147c-2.115 1.058-4.393 1.547-6.914 1.547H51.559v20.738h-7.32V63.32h24.156c1.463 0 2.846-.244 4.066-.893 1.22-.652 2.278-1.465 3.172-2.603.813-1.139 1.465-2.36 2.034-3.904a14.57 14.57 0 0 0 .731-4.636 13.1 13.1 0 0 0-.895-4.718 12.902 12.902 0 0 0-2.277-3.823c-.976-1.057-2.114-1.87-3.335-2.52-1.3-.57-2.602-.895-3.984-.895H51.56V55.92h-7.32v-23.1h24.074c2.522 0 4.88.57 6.995 1.627 2.114 1.057 3.985 2.44 5.53 4.23a21.29 21.29 0 0 1 3.66 5.937c.814 2.197 1.302 4.392 1.302 6.67 0 2.44-.407 4.716-1.22 6.912z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteIconPrilogin);
export default __webpack_public_path__ + "static/media/white-icon-prilogin.47d034d4b23e51289c2a625d9fcbb069.svg";
export { ForwardRef as ReactComponent };